var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-item nav-link",class:{'active': _vm.isActive},attrs:{"data-toggle":"tab","href":("#" + _vm.id),"role":"tab","aria-controls":"nav-all","aria-selected":"true"}},[_vm._v(_vm._s(_vm.title)+" ("+_vm._s(_vm.count)+")")])}
var staticRenderFns = []

export { render, staticRenderFns }